import { render, staticRenderFns } from "./CreateAlert.vue?vue&type=template&id=e380043c&"
import script from "./CreateAlert.vue?vue&type=script&lang=js&"
export * from "./CreateAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports